export function seoTitle(title: string | undefined) {
  return title ? `${title} | HADB.ME` : 'HADB.ME'
}
